import 'aos/dist/aos.css';
import AOS from 'aos';

const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

/**
 * Setup AOS library for animation
 */
AOS.init({
  delay: 0,
  disable: window.innerWidth < 1280 || isIE11,
  duration: 350,
  easing: 'ease-in-out',
  offset: 100
});

window.addEventListener('resize', function() {
  AOS.refresh();
});
